/* ARSHÉ FINAL POLISH V17
   - once-per-session minimal preloader
   - single touch-first infinite fragrance carousel
   - exact center snapping
   - circular 7-fragrance loop
   - clean 30/50 ML controls
*/
(function () {
  'use strict';

  function initPreloader() {
    var preloader = document.getElementById('luxePreloader');
    if (!preloader) return;

    // V17: show once per browsing session. Internal page navigation in the
    // same tab/session must never replay the preloader. The early <head>
    // sessionStorage check hides it before paint on subsequent pages.
    if (document.documentElement.classList.contains('arshe-preloader-seen')) {
      preloader.remove();
      return;
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.body.classList.add('luxe-loading');

    requestAnimationFrame(function () {
      var delay = reduce ? 650 : 1200;
      var removeDelay = reduce ? 800 : 1550;
      setTimeout(function () {
        preloader.classList.add('hiding');
        document.body.classList.remove('luxe-loading', 'luxe-flying');
        document.body.classList.add('luxe-header-visible');
      }, delay);
      setTimeout(function () { if (preloader.parentNode) preloader.remove(); }, removeDelay);
    });
  }

  function initCarousel(root) {
    if (window.__ARSHE_V11_NATIVE_CAROUSEL__) return;
    if (!root || root.dataset.arsheV9Ready === '1') return;
    var track = root.querySelector('[data-carousel-track]');
    var originals = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    var section = root.closest('.arshe-collection-v2') || root.parentElement;
    if (!track || originals.length < 2 || !section) return;
    root.dataset.arsheV9Ready = '1';

    var count = originals.length;
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    var dots = section.querySelector('[data-carousel-dots]');
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-size-tab]'));
    var current = 0;
    var settleTimer = 0;
    var ignoreScroll = false;
    var pointerStartX = 0;
    var pointerMoved = false;
    var pointerId = null;

    // Three identical sets. The middle set is the real working set.
    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    originals.forEach(function (slide) {
      var b = slide.cloneNode(true);
      var a = slide.cloneNode(true);
      b.dataset.arsheClone = 'before';
      a.dataset.arsheClone = 'after';
      before.appendChild(b);
      after.appendChild(a);
    });
    track.insertBefore(before, track.firstChild);
    track.appendChild(after);

    function slides() {
      return Array.prototype.slice.call(track.querySelectorAll('[data-carousel-slide]'));
    }

    function realIndex(allIndex) {
      var r = (allIndex - count) % count;
      return r < 0 ? r + count : r;
    }

    function targetLeft(slide) {
      return slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
    }

    function centerAllIndex(index, behavior) {
      var all = slides();
      var slide = all[index];
      if (!slide) return;
      var left = Math.max(0, targetLeft(slide));
      ignoreScroll = behavior === 'auto';
      track.scrollTo({ left: left, behavior: behavior || 'smooth' });
      if (behavior === 'auto') {
        requestAnimationFrame(function () { ignoreScroll = false; });
      }
    }

    function updateUI(allIndex) {
      current = realIndex(allIndex);
      var all = slides();
      all.forEach(function (slide, i) {
        var r = realIndex(i);
        var active = i === allIndex;
        slide.classList.toggle('is-near-center', active);
        slide.setAttribute('aria-current', active ? 'true' : 'false');
        slide.style.setProperty('--arshe-carousel-distance', active ? '0' : '1');
        slide.dataset.realIndex = r;
      });
      if (dots) {
        Array.prototype.forEach.call(dots.querySelectorAll('button'), function (dot, i) {
          var active = i === current;
          dot.classList.toggle('active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }
    }

    function nearestIndex() {
      var all = slides();
      var viewportCenter = track.scrollLeft + track.clientWidth / 2;
      var best = count;
      var bestDistance = Infinity;
      all.forEach(function (slide, i) {
        var center = slide.offsetLeft + slide.offsetWidth / 2;
        var d = Math.abs(center - viewportCenter);
        if (d < bestDistance) { bestDistance = d; best = i; }
      });
      return best;
    }

    function settle() {
      if (ignoreScroll) return;
      var all = slides();
      if (!all.length) return;
      var nearest = nearestIndex();
      updateUI(nearest);

      // If the user reached either cloned edge, jump to the identical card
      // in the middle set with no animation. Because the artwork is identical,
      // the recenter is visually invisible and the loop never ends.
      if (nearest < count || nearest >= count * 2) {
        var middle = count + current;
        centerAllIndex(middle, 'auto');
        updateUI(middle);
        return;
      }

      // Final pixel-perfect snap after momentum stops.
      var slide = all[nearest];
      var target = Math.max(0, targetLeft(slide));
      if (Math.abs(track.scrollLeft - target) > 1.5) {
        track.scrollTo({ left: target, behavior: 'smooth' });
      }
    }

    function scheduleSettle() {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 95);
    }

    function go(real, behavior) {
      var normalized = ((real % count) + count) % count;
      current = normalized;
      centerAllIndex(count + normalized, behavior || 'smooth');
      updateUI(count + normalized);
    }

    function makeDots() {
      if (!dots) return;
      dots.innerHTML = '';
      originals.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'luxe-carousel__dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'View fragrance ' + (i + 1));
        dot.addEventListener('click', function () { go(i, 'smooth'); });
        dots.appendChild(dot);
      });
    }

    function updateCard(card, size) {
      var suffix = size.replace('ml', '');
      var price = card.querySelector('.arshe-product-card__price');
      var links = card.querySelectorAll('.arshe-product-card__link, .arshe-product-card__media');
      var id = card.getAttribute('data-v' + suffix + '-id');
      var url = card.getAttribute('data-v' + suffix + '-url') || card.getAttribute('data-product-url') || '#';
      var priceText = card.getAttribute('data-v' + suffix + '-price') || '—';
      if (price) price.textContent = priceText;
      Array.prototype.forEach.call(links, function (link) { link.href = url; });
      Array.prototype.forEach.call(card.querySelectorAll('[data-size-choice]'), function (button) {
        var active = button.getAttribute('data-size-choice') === size;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.disabled = !card.getAttribute('data-v' + button.getAttribute('data-size-choice').replace('ml', '') + '-id');
      });
      card.classList.toggle('is-unavailable-size', !id);
    }

    function setSize(size, source) {
      var cards = slides();
      if (source) {
        var card = source.closest('.arshe-product-card');
        if (card) updateCard(card, size);
      } else {
        cards.forEach(function (card) { updateCard(card, size); });
      }
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-size-tab') === size;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    makeDots();

    if (prev) prev.addEventListener('click', function () { go(current - 1, 'smooth'); });
    if (next) next.addEventListener('click', function () { go(current + 1, 'smooth'); });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setSize(tab.getAttribute('data-size-tab'));
      });
    });

    // Event delegation means cloned cards behave exactly like originals.
    track.addEventListener('click', function (event) {
      var sizeButton = event.target.closest('[data-size-choice]');
      if (sizeButton) {
        event.preventDefault();
        event.stopPropagation();
        setSize(sizeButton.getAttribute('data-size-choice'), sizeButton);
      }
      if (pointerMoved && (event.target.closest('a') || event.target.closest('button'))) {
        event.preventDefault();
        event.stopPropagation();
        pointerMoved = false;
      }
    }, true);

    track.addEventListener('pointerdown', function (event) {
      pointerStartX = event.clientX;
      pointerMoved = false;
      pointerId = event.pointerId;
    }, { passive: true });

    track.addEventListener('pointermove', function (event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      if (Math.abs(event.clientX - pointerStartX) > 8) pointerMoved = true;
    }, { passive: true });

    function clearPointer() { pointerId = null; }
    track.addEventListener('pointerup', clearPointer, { passive: true });
    track.addEventListener('pointercancel', clearPointer, { passive: true });

    track.addEventListener('scroll', function () {
      if (ignoreScroll) return;
      var all = slides();
      var viewportCenter = track.scrollLeft + track.clientWidth / 2;
      all.forEach(function (slide, i) {
        var center = slide.offsetLeft + slide.offsetWidth / 2;
        var d = Math.abs(center - viewportCenter) / Math.max(1, slide.offsetWidth * 1.15);
        slide.style.setProperty('--arshe-distance', Math.min(1, d).toFixed(3));
      });
      var nearest = nearestIndex();
      updateUI(nearest);
      scheduleSettle();
    }, { passive: true });

    // Prevent horizontal wheel gestures from fighting vertical page scrolling.
    track.addEventListener('wheel', function (event) {
      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) event.preventDefault();
    }, { passive: false });

    setSize('30ml');

    function initialCenter() {
      var all = slides();
      if (!all.length) return;
      centerAllIndex(count, 'auto');
      updateUI(count);
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(initialCenter);
      setTimeout(initialCenter, 250);
    });

    window.addEventListener('resize', function () {
      requestAnimationFrame(function () { centerAllIndex(count + current, 'auto'); updateUI(count + current); });
    }, { passive: true });
  }

  function init() {
    initPreloader();
    document.querySelectorAll('[data-arshe-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) {
      event.target.querySelectorAll('[data-arshe-carousel]').forEach(initCarousel);
    }
  });
})();
